import React, { useEffect, useRef, useState } from "react";
import img from "../../assets/png.png";
import axios from "axios";
import { toast } from "react-toastify";

function Webpage() {
  const [cities, setCities] = useState([]);
  const [categories, setCategories] = useState([]);
  const [business, setBusiness] = useState(null);
  const [fullName, setFullName] = useState("");
  const [mobile, setMobile] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [pincode, setPincode] = useState("");
  const [services, setServices] = useState([]);
  const [userData, setUserData] = useState(null);
  const [selectedServices, setSelectedServices] = useState([]);
  const [description, setDescription] = useState("");
  const [userId, setUserId] = useState(localStorage.getItem("userId"));
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [rateCardData, setRateCardData] = useState([]);
  const serviceSectionRef = useRef(null);
  const [showRateCard, setShowRateCard] = useState(false);
  const [textPrices, setTextPrices] = useState([]);
  const [loading, setLoading] = useState(true);
  const adRef = useRef(null);

  /* ------------------------------------------------------------------ */
  /* -------------------------- DATA FETCHING ------------------------ */
  /* ------------------------------------------------------------------ */
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (token) localStorage.setItem("authToken", token);
  }, []);

  useEffect(() => {
    axios
      .get("https://visitguru.in/api/v1/city/getCity")
      .then((res) => {
        if (res.data.success) setCities(res.data.data);
      })
      .catch((err) => console.error("Error fetching cities:", err.message));
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (!token) return;
    axios
      .get("https://visitguru.in/api/v1/freelancer/getfreelancer", {
        headers: { Authorization: token },
      })
      .then(async (res) => {
        const data = res.data.data;
        const shopId = data._id;
        localStorage.setItem("shopId", shopId);
        try {
          const countRes = await axios.get(
            `https://visitguru.in/api/v1/freelancer/getVendor/${shopId}`
          );
          const totalServices = countRes.data.serviceCount || 0;
          data.totalServicesCompleted = totalServices;
          data.totalServices = totalServices;
        } catch (countErr) {
          console.error("Error fetching service count:", countErr);
          data.totalServicesCompleted = 0;
          data.totalServices = 0;
        }
        if (data.city) {
          localStorage.setItem("cityId", data.city._id);
          localStorage.setItem("cityName", data.city.cityName);
        }
        setBusiness(data);
      })
      .catch((err) => console.error("Error fetching business:", err));
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (!token) return;
    axios
      .get("https://visitguru.in/api/v1/category/getCatbyShop", {
        headers: { Authorization: token },
      })
      .then((res) => setCategories(res.data.data))
      .catch((err) =>
        console.error(
          "Error fetching categories:",
          err.response ? err.response.data : err.message
        )
      );
  }, []);

  useEffect(() => {
    const _id = localStorage.getItem("userId");
    if (_id) {
      axios
        .post("https://visitguru.in/api/v1/user/getUserbyId", { _id })
        .then((res) => setUserData(res.data.data))
        .catch((err) => console.error("Error fetching user data:", err));
    }
  }, [userId]);

  /* ------------------------------------------------------------------ */
  /* -------------------------- USER ACTIONS ------------------------ */
  /* ------------------------------------------------------------------ */
  const handleAddUser = async (e) => {
    e.preventDefault();
    if (!fullName || !mobile || !address || !city || !pincode) {
      return alert("Please fill all fields");
    }
    const fd = new FormData();
    fd.append("fullName", fullName);
    fd.append("mobile", mobile);
    fd.append("address", address);
    fd.append("city", city);
    fd.append("pincode", pincode);
    try {
      const res = await axios.post(
        "https://visitguru.in/api/v1/user/addUser",
        fd
      );
      if (res.data.success) {
        // toast.success("Added Successfully");
        const newUserId = res.data.data._id;
        localStorage.setItem("userId", newUserId);
        setUserId(newUserId);
        setUserData(res.data.data);
      } else {
        alert("Try Again");
      }
    } catch (err) {
      alert("An error occurred. Please try again.");
      console.error("Error adding user:", err);
    }
  };

  const handleCategoryClick = async (categoryId) => {
    // 🧹 Clear previous data first
    setRateCardData([]);
    setServices([]);

    // set selected category
    setSelectedCategoryId(categoryId);
    setShowRateCard(true);

    const shopId = localStorage.getItem("shopId");
    if (!shopId) return alert("Shop ID not found.");

    try {
      // 🧠 1️⃣ Fetch services by category
      const response = await axios.post(
        "https://visitguru.in/api/v1/service/getServicebyCat",
        { categoryId, shopId },
        { headers: { Authorization: localStorage.getItem("authToken") } }
      );

      if (response.data.success && Array.isArray(response.data.data)) {
        const fetchedServices = response.data.data.map((service) => ({
          _id: service._id,
          serviceName: service.serviceName,
          price: service.price,
          quantity: 0,
        }));

        setServices(fetchedServices);

        // optional smooth scroll
        setTimeout(() => {
          serviceSectionRef.current?.scrollIntoView({ behavior: "smooth" });
        }, 200);
      } else {
        setServices([]);
      }
    } catch (error) {
      console.error("Error fetching services:", error);
      setServices([]);
    }

    // 🧠 2️⃣ Now fetch rate card for the same category
    await getRatecard(categoryId);
  };
  const serviceBook = async (e) => {
    e.preventDefault();
    const userID = localStorage.getItem("userId");
    const shopID = localStorage.getItem("shopId");
    if (!userID || !shopID || selectedServices.length === 0) {
      return alert("Please fill all fields and select a service.");
    }
    const serviceID = selectedServices
      .filter((s) => s.quantity > 0)
      .map((s) => ({ service: s._id, quantity: s.quantity }));
    try {
      const response = await axios.post(
        "https://visitguru.in/api/v1/bookservice/userbook",
        { userID, shopID, serviceID, description },
        { headers: { "Content-Type": "application/json" } }
      );
      if (response.data.success) {
        toast.success(response.data.message);
        alert(`${business?.shopName} - ${response.data.message}`);
        localStorage.removeItem("userId");
        window.location.reload();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Booking failed.");
    }
  };

  /* ------------------------------------------------------------------ */
  /* -------------------------- RATE CARD -------------------------- */
  /* ------------------------------------------------------------------ */
  const getRatecard = async (categoryId) => {
    const token = localStorage.getItem("authToken");
    if (!token) return alert("Authorization token missing.");

    try {
      const response = await axios.post(
        "https://visitguru.in/api/v1/ratecard/getRatecard",
        { category: categoryId },
        { headers: { Authorization: token } }
      );

      if (response.data?.success && Array.isArray(response.data.data)) {
        // ✅ Filter only current category data
        const filtered = response.data.data.filter(
          (item) => item.category?._id === categoryId
        );

        // remove duplicates (Description + ServiceCharge)
        const uniqueData = Array.from(
          new Map(
            filtered.map((item) => [
              `${item.Description}|${item.ServiceCharge}`,
              item,
            ])
          ).values()
        );

        // enrich with category name
        const enriched = uniqueData.map((item) => ({
          ...item,
          categoryName:
            item?.category?.categoryName ||
            categories.find((c) => c._id === categoryId)?.categoryName ||
            "Uncategorized",
        }));

        setRateCardData(enriched);
      } else {
        setRateCardData([]);
      }
    } catch (error) {
      console.error("Error fetching rate card:", error);
      setRateCardData([]);
    }
  };
  const handleToggleRatecard = async () => {
    if (!showRateCard && selectedCategoryId) {
      await getRatecard(selectedCategoryId);
    }
    setShowRateCard((prev) => !prev);
  };

  useEffect(() => {
    setShowRateCard(false);
    setRateCardData([]);
  }, [selectedCategoryId]);

  /* ------------------------------------------------------------------ */
  /* -------------------------- OTHER ------------------------------- */
  /* ------------------------------------------------------------------ */
  const fetchTextPrices = async () => {
    try {
      const res = await axios.get("https://visitguru.in/api/textprice", {
        headers: { Authorization: localStorage.getItem("authToken") },
      });
      if (res.data.success) setTextPrices(res.data.data);
    } catch (err) {
      console.error("Error fetching text prices:", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => fetchTextPrices(), []);

  useEffect(() => {
    try {
      if (adRef.current && !adRef.current.dataset.adStatus) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        adRef.current.dataset.adStatus = "loaded";
      }
    } catch (err) {
      console.error("AdSense error:", err);
    }
  }, []);

  /* ------------------------------------------------------------------ */
  /* ------------------------------ UI ----------------------------- */
  /* ------------------------------------------------------------------ */
  return (
    <div
      style={{
        width: "100%",
        maxWidth: "430px",
        margin: "0 auto",
        border: "1px solid #ccc",
        boxShadow: "0 0 15px rgba(0,0,0,0.1)",
        borderRadius: "12px",
        overflow: "hidden",
        backgroundColor: "#fff",
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}>
      <div className="w-full p-2 border rounded-lg shadow-lg bg-white space-y-4 overflow-hidden">
        {/* Business Info */}
        <div className="flex justify-between items-start mt-4">
          {/* Left Side: Profile Info */}
          <div className="flex items-center gap-4 flex-1 min-w-0">
            <img
              src={business?.image || "https://placehold.co/64"}
              alt="Business Logo"
              className="w-16 h-16 rounded-full border shadow-md profile-image flex-shrink-0"
            />
            <div className="min-w-0">
              {/* Business Name with fixed width 25px */}
              <p
                className="text-lg font-bold business-name break-words whitespace-normal leading-tight"
                style={{
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                  width: "150px",
                  paddingLeft: "10px",
                }}
                title={business?.shopName}>
                {business?.shopName || "Business Name"}
              </p>

              <p className="text-sm text-gray-500 owner-name" style={{ paddingLeft: "10px" }}>
                {business?.firstName || "First"} {business?.lastName || "Last"}
              </p>
              <p className="text-sm text-gray-500 location" style={{ paddingLeft: "10px" }}>
                {Array.isArray(business?.city) 
                  ? (typeof business.city[0] === 'object' ? business.city[0]?.cityName : business.city[0]) 
                  : business?.city?.cityName || business?.city || "City"}
              </p>
              <div className="bg-teal-500 text-white text-xs py-1 px-2 ml-2 rounded-lg inline-block services-completed mt-1">
                {business?.totalServices || 0} Services Completed
              </div>
            </div>
          </div>

          {/* Right Side: Fixed Logo */}
          <div
            className="flex-shrink-0 self-start ml-4"
            style={{ paddingRight: "25px" }}>
            <img
              src={img}
              alt="Visitguru Logo"
              className="h-10 object-contain"
            />
          </div>
        </div>

        {/* Categories */}
        <div className="mt-4">
          <p className="font-semibold">Service & Products</p>
          <div className="flex flex-wrap gap-2 mt-2">
            {categories.map((category) => (
              <button
                style={{ width: "166px", fontSize: "12px" }}
                key={category._id}
                className={`flex items-center gap-2 py-2 px-4 rounded-lg border transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-1 ${selectedCategoryId === category._id
                  ? "bg-teal-500 text-white border-teal-500"
                  : "bg-teal-500 text-white border-teal-500"
                  }`}
                onClick={() => handleCategoryClick(category._id)}>
                <img
                  src={category.catimg}
                  alt={category.categoryName}
                  style={{ height: "30px", width: "30px" }}
                />
                {category.categoryName}
              </button>
            ))}
          </div>
        </div>

        {/* Services */}
        <form style={{ color: "#212529", borderColor: " #dee2e6" }}>
          <div
            ref={serviceSectionRef}
            tabIndex={-1}
            className="mt-4 space-y-2 outline-none">
            {services.length > 0 ? (
              services.map((service) => {
                const selected = selectedServices.find(
                  (s) => s._id === service._id
                );
                const quantity = selected ? selected.quantity : 0;

                const handleQuantityChange = (changeBy) => {
                  const newQty = quantity + changeBy;
                  if (newQty < 0) return;

                  setServices((prev) =>
                    prev.map((s) =>
                      s._id === service._id ? { ...s, quantity: newQty } : s
                    )
                  );

                  setSelectedServices((prev) => {
                    if (newQty === 0) {
                      return prev.filter((s) => s._id !== service._id);
                    }
                    const exists = prev.find((s) => s._id === service._id);
                    if (exists) {
                      return prev.map((s) =>
                        s._id === service._id ? { ...s, quantity: newQty } : s
                      );
                    }
                    return [...prev, { ...service, quantity: newQty }];
                  });
                };

                const handleAddToSelected = (e) => {
                  e.preventDefault();
                  handleQuantityChange(1);
                };

                return (
                  <div
                    key={service._id}
                    className={`flex items-center justify-between border p-2 rounded-lg shadow-md bg-gray-100 ${quantity > 0 ? "bg-teal-50 border-teal-400" : "bg-gray-50"
                      }`}>
                    <div className="text-teal-500 text-xl">🛒</div>
                    <div className="ml-4 flex-1">
                      <p className="font-semibold">{service.serviceName}</p>
                      <p className="text-sm text-gray-500">
                        Rs. {service.price || "N/A"}/-
                      </p>
                    </div>
                    {quantity > 0 ? (
                      <div
                        style={{ display: "flex", flexDirection: "row" }}
                        className="py-2 px-4 mt-2 bg-teal-500 text-white rounded-lg hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-1">
                        <button
                          type="button"
                          onClick={() => handleQuantityChange(-1)}
                          className="w-5 h-5 bg-white text-black text-lg font-bold rounded-full flex items-center justify-center shadow focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-1">
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            aria-hidden>
                            <path
                              d="M5 12h14"
                              stroke="black"
                              strokeWidth="2.2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              fill="none"
                            />
                          </svg>
                        </button>

                        <div className="text-base font-semibold w-6 text-center ml-1 mr-1 text-white">
                          {quantity}
                        </div>

                        <button
                          type="button"
                          onClick={() => handleQuantityChange(1)}
                          className="w-5 h-5 bg-white text-black text-lg font-bold rounded-full flex items-center justify-center shadow focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-1">
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            aria-hidden>
                            <path
                              d="M12 5v14M5 12h14"
                              stroke="black"
                              strokeWidth="2.2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              fill="none"
                            />
                          </svg>
                        </button>
                      </div>
                    ) : (
                      <button
                        type="button"
                        onClick={handleAddToSelected}
                        className="py-2 px-4 mt-2 bg-teal-500 text-white rounded-lg hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-1">
                        Add
                      </button>
                    )}
                  </div>
                );
              })
            ) : (
              <p>No services available.</p>
            )}
          </div>
        </form>

        {/* Rate Card Button */}
        <div className="mt-4">
          <button
            onClick={() => {
              if (!selectedCategoryId) {
                alert("Please select a category first");
                return;
              }
              handleToggleRatecard();
            }}
            className="w-full bg-teal-500 text-white py-3 rounded-lg hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-1">
            Rate Card
          </button>
        </div>

        {/* Rate Card Display */}
        {showRateCard && rateCardData.length > 0 && (
          <div className="mt-4 space-y-2">
            <h2 className="text-xl font-bold text-teal-600 mb-2">
              Rate Card List
            </h2>
            <div className="border rounded-xl shadow overflow-hidden">
              <div className="bg-teal-600 text-teal px-4 py-3 flex justify-between items-center rounded-t-xl">
                <div>
                  <h2 className="font-semibold text-lg">
                    {categories.find((c) => c._id === selectedCategoryId)
                      ?.categoryName || "Rate Card"}{" "}
                    Services
                  </h2>
                  <div className="rate-card-header flex justify-between" style={{ gap: "160px" }}>
                    <h3 className="py-2 border-b">Description</h3>
                    <h3 className="px-4 py-2 border-b">Charge</h3>
                  </div>
                </div>
              </div>
              <div
                className="overflow-y-auto"
                style={{ maxHeight: `${3 * 48}px` }}>
                <table className="w-full text-sm text-left border rounded-lg">
                  <tbody className="text-gray-800 bg-white">
                    {rateCardData.map((item, i) => (
                      <tr key={i} className="border-t">
                        <td className="px-4 py-2">{item.Description}</td>
                        <td className="px-4 py-2">₹{item.ServiceCharge}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {/* User Form */}
        <form className="space-y-4" style={{ borderColor: " #dee2e6" }}>
          <div style={{ borderColor: "#dee2e6" }}>
            <label className="block mt-3 font-semibold">Customer Name</label>
            <input
              style={{ borderColor: "#dee2e6" }}
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              type="text"
              placeholder="Customer Name"
              className="w-full p-2 border rounded-lg bg-gray-100 focus:outline-none focus:ring-2 focus:ring-teal-500"
            />
          </div>
          <div>
            <label className="block mb-1 font-semibold">Mobile Number</label>
            <input
              style={{ borderColor: "#dee2e6" }}
              value={mobile}
              onChange={(e) =>
                /^\d{0,10}$/.test(e.target.value) && setMobile(e.target.value)
              }
              type="text"
              placeholder="Mobile Number"
              maxLength={10}
              className="w-full p-2  rounded-lg bg-gray-100 focus:outline-none focus:ring-2 focus:ring-teal-500"
            />
          </div>
          <div>
            <label className="block mb-1 font-semibold">Address</label>
            <textarea
              style={{ borderColor: "#dee2e6" }}
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              placeholder="Address"
              className="w-full p-2  rounded-lg bg-gray-100 focus:outline-none focus:ring-2 focus:ring-teal-500 overflow-hidden resize-none"
            />
          </div>
          <label className="block mb-1 font-semibold">City/Village</label>
          <input
            style={{ borderColor: "#dee2e6" }}
            type="text"
            list="city-options"
            value={city}
            onChange={(e) => setCity(e.target.value)}
            className="w-full p-2  rounded-lg bg-gray-100 focus:outline-none focus:ring-2 focus:ring-teal-500"
            placeholder="Enter City/Village"
          />
          <datalist id="city-options">
            {cities.map((c) => (
              <option key={c._id} value={c.cityName} />
            ))}
          </datalist>
          <div>
            <label className="block mb-1 font-semibold">Pincode</label>
            <input
              style={{ borderColor: "#dee2e6" }}
              value={pincode}
              onChange={(e) =>
                /^\d{0,6}$/.test(e.target.value) && setPincode(e.target.value)
              }
              type="text"
              placeholder="Pincode"
              className="w-full p-2 mb-2 border rounded-lg bg-gray-100 focus:outline-none focus:ring-2 focus:ring-teal-500"
            />
          </div>
          <button
            onClick={handleAddUser}
            type="button"
            className="w-full bg-teal-500 text-white py-2 rounded-lg hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-1">
            Add
          </button>
        </form>

        {/* User Data */}
        {userId && userData && (
          <div className="mt-6 border rounded-lg shadow-md p-4">
            <p className="font-semibold">Customer Name: {userData.fullName}</p>
            <p>Address: {userData.address}</p>
            <p>Mobile:+91 {userData.mobile}</p>
            <p>City: {userData.city}</p>
            <p>Pincode: {userData.pincode}</p>
          </div>
        )}

        {/* Selected Services */}
        <div className="mt-4">
          <p className="font-semibold">Selected Services</p>
          {selectedServices.length > 0 ? (
            selectedServices.map((service) => (
              <div
                key={service._id}
                className="flex items-center border p-2 rounded-lg shadow-md bg-gray-100">
                <div className="text-teal-500">🛒</div>
                <div className="ml-4 flex-1">
                  <p className="font-semibold">{service.serviceName}</p>
                  <p className="text-sm text-gray-500">
                    Rs. {service.price || 0}/- Qty: {service.quantity || 0}
                  </p>
                </div>
                <button
                  className="w-8 h-8 rounded-full bg-red-500 flex items-center justify-center text-white cursor-pointer focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-1"
                  onClick={() => {
                    setSelectedServices((prev) =>
                      prev.filter((s) => s._id !== service._id)
                    );
                    setServices((prev) =>
                      prev.map((s) =>
                        s._id === service._id ? { ...s, quantity: 0 } : s
                      )
                    );
                  }}>
                  X
                </button>
              </div>
            ))
          ) : (
            <p>No services selected.</p>
          )}
        </div>

        {/* Description */}
        <div className="mt-4">
          <label className="block mb-1 font-semibold">Description</label>
          <textarea
            style={{ borderColor: "#dee2e6" }}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Add Description..."
            className="w-full p-2 border rounded-lg bg-gray-100 focus:outline-none focus:ring-2 focus:ring-teal-500"
          />
        </div>

        {/* Inclusions */}
        <div className="max-w-sm mx-auto bg-white rounded-lg shadow-md p-4 border border-gray-200">
          <h3 className="text-center text-green-600 font-semibold text-lg border-b border-green-500 pb-1 mb-3">
            Inclusions
          </h3>
          <ul className="space-y-2 text-gray-700 text-sm">
            <li className="flex items-start">
              <span className="text-green-600 text-lg mr-2">✅</span>
              <span>Price includes visit & diagnosis.</span>
            </li>
            <li className="flex items-start">
              <span className="text-green-600 text-lg mr-2">✅</span>
              <span>Repair costs will be provided after diagnosis.</span>
            </li>
            <li className="flex items-start">
              <span className="text-green-600 text-lg mr-2">✅</span>
              <span>
                Visitation charge will be adjusted in the repair cost.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-green-600 text-lg mr-2">✅</span>
              <span>100% hassle-free, 100% mess-free service.</span>
            </li>
          </ul>
        </div>

        {/* Book Button */}
        <button
          onClick={serviceBook}
          className="w-full bg-teal-500 text-white py-3 mt-4 rounded-lg hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-1 font-bold">
          Book
        </button>
      </div>
    </div>
  );
}

export default Webpage;
